import { useQueryStates } from "nuqs";
import {
  createLoader,
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
  parseAsFloat,
  parseAsInteger,
  createSerializer,
} from "nuqs/server";

import {
  bankSearchParam,
  filterSearchParam,
  modalitySearchParam,
  paymentSearchParam,
  sortingSearchParam,
  typeSearchParam,
} from "@/filters";
import { defaultSortingCriteria, defaultTypeCriteria } from "@/constants";

const arraySeparator = ",";

const searchParams = {
  [filterSearchParam.cidade]: parseAsArrayOf(
    parseAsString,
    arraySeparator
  ).withDefault([]),
  [filterSearchParam.ordenar]: parseAsStringLiteral(
    sortingSearchParam
  ).withDefault(defaultSortingCriteria),
  [filterSearchParam.tipo]:
    parseAsStringLiteral(typeSearchParam).withDefault(defaultTypeCriteria),
  [filterSearchParam.pagamento]: parseAsArrayOf(
    parseAsStringLiteral(paymentSearchParam),
    arraySeparator
  ).withDefault([]),
  [filterSearchParam.modalidade]: parseAsArrayOf(
    parseAsStringLiteral(modalitySearchParam),
    arraySeparator
  ).withDefault([]),
  [filterSearchParam.banco]: parseAsArrayOf(
    parseAsStringLiteral(bankSearchParam),
    arraySeparator
  ).withDefault([]),
  [filterSearchParam.precoMax]: parseAsFloat,
  [filterSearchParam.precoMin]: parseAsFloat,
  [filterSearchParam.tamanhoPropriedade]: parseAsFloat,
  [filterSearchParam.tamanhoArea]: parseAsFloat,
  [filterSearchParam.pesquisa]: parseAsString.withDefault(""),
  [filterSearchParam.pagina]: parseAsInteger.withDefault(1),
  q: parseAsString,
};

export const useFilter = () =>
  useQueryStates(searchParams, {
    clearOnDefault: true,
  });

export const loadFilterSearchParams = createLoader(searchParams);

export const serializeFilterSearchParams = createSerializer(searchParams);
